<template>
  <!-- DateRangeCustomPluginBiz -->
  <date-range-custom-plugin-biz
    :initRange="storedDateRange"
    :captions="captions"
    :months="months"
    :shortDays="shortDays"
    :rightToLeft="true"
    :hasDateToUse="hasDateToUse"
    :initDateToUse="dateToUse"
    :dateToUseValues="dateToUseValues"
    @applyrange="applyRange"
    @cleardaterange="resetRange"
  ></date-range-custom-plugin-biz>
</template>

<script>
import DateRangeCustomPluginBiz from "./DateRangeCustomPluginBiz";
import dayjs from "dayjs";

export default {
  components: {
    DateRangeCustomPluginBiz
  },
  props: {
    dateToUseValues: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    },
    hasDateToUse: {
      type: Boolean,
      required: true,
      default: false
    },
    dateToUse: {
      type: String,
      required: false,
      default: ""
    },
    storedDateRange: {
      type: Object,
      required: false,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      months: [
        this.$t("component.datePicker.months.january"),
        this.$t("component.datePicker.months.february"),
        this.$t("component.datePicker.months.march"),
        this.$t("component.datePicker.months.april"),
        this.$t("component.datePicker.months.may"),
        this.$t("component.datePicker.months.june"),
        this.$t("component.datePicker.months.july"),
        this.$t("component.datePicker.months.august"),
        this.$t("component.datePicker.months.september"),
        this.$t("component.datePicker.months.october"),
        this.$t("component.datePicker.months.november"),
        this.$t("component.datePicker.months.december")
      ],
      shortDays: [
        this.$t("component.datePicker.shortDays.sunday"),
        this.$t("component.datePicker.shortDays.monday"),
        this.$t("component.datePicker.shortDays.tuesday"),
        this.$t("component.datePicker.shortDays.wednesday"),
        this.$t("component.datePicker.shortDays.thursday"),
        this.$t("component.datePicker.shortDays.friday"),
        this.$t("component.datePicker.shortDays.saturday")
      ],
      captions: {
        title: this.$t("component.datePicker.title"),
        ok_button: this.$t("component.datePicker.actionBtn")
      },
      pluginDateFormat: "YYYY-MM-DD"
    };
  },
  created() {},
  computed: {},
  methods: {
    initialize() {},
    async resetRange() {
      let selectedDateRange = {
        start: null,
        end: null
      };
      this.applyRange(selectedDateRange, "");
    },
    async applyRange(selectedDateRange, selectedDateToUse) {
      let dateToUseToStore = null;
      if (this.hasDateToUse) {
        dateToUseToStore = selectedDateToUse;
      }
      let sdrStart = selectedDateRange.start ? selectedDateRange.start : null;
      let sdrEnd = selectedDateRange.end ? selectedDateRange.end : null;
      let start = sdrStart
        ? dayjs(sdrStart).format(this.pluginDateFormat)
        : null;
      let end = sdrEnd ? dayjs(sdrEnd).format(this.pluginDateFormat) : null;
      let dateRangeToStore = {
        start: start,
        end: end
      };
      let payload = {
        dtu: dateToUseToStore,
        dr: dateRangeToStore
      };
      await this.$emit("onset", payload);
      await this.$emit("onsearch", payload);
    }
  }
};
</script>
